export default {"src":"/_next/static/media/pluot.5138d634.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};